module.exports = __webpack_public_path__ + "static/img/zzjg.38acaf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzjg.jpg
// module id = 298
// module chunks = 0 1 2 3 4 5 6 7 8 9